// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import hooks
import { useMutation, useQueryClient } from 'react-query';

// import queries & mutations
import { addEmployeeNote } from 'RestAPIs/employees/notes';

// import types
import { AddEmployeeNoteParams } from './useAddEmployeeNote.types';

const useAddEmployeeNote = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: AddEmployeeNoteParams) => addEmployeeNote(params),
    {
      onSuccess: (_data, { employeeId }) => {
        queryClient.invalidateQueries(['employeeNotes', 'list', employeeId]);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useAddEmployeeNote;
